import classNames from 'classnames'
import { Card } from 'react-bootstrap'

import Image from '../ui/Image/Image'
import Title from '../ui/Title/Title'
import CountUpAnimation from '../CountUpAnimation/CountUpAnimation'
import { getImageUrl } from '../../utils'
import styles from './Outcome.module.scss'

const Grid = ({ grids = [] }) =>
  grids.map((item) => {
    const { id, title, number, image, description, gridType } = item
    return (
      <Card
        key={id}
        className={classNames(styles.cardContainer, styles[gridType])}
      >
        <div className={styles.titleContainer}>
          <Title title={title} classname={styles.title} />
          {image?.url && (
            <div className={styles.imageContainer}>
              <Image alt={image?.alternativeText} src={getImageUrl(image)} />
            </div>
          )}
        </div>
        <CountUpAnimation
          localeFormat={number.localeFormat || 'en-In'}
          initialValue={0}
          targetValue={number?.label ? +number?.label : number?.value || 0}
          text={number.suffix}
          prefix={number.prefix}
          className={classNames(styles.numbers, {
            [styles[number?.small_text]]: number?.small_text,
          })}
        />
        <div className={styles.descriptionContainer}>
          <span className={styles.description}>{description}</span>
        </div>
      </Card>
    )
  })

function Outcome({ widgetDetails: outcomeDetails }) {
  const { title: heading, outcome } = outcomeDetails

  return (
    <div className={classNames(styles.rootContainer)}>
      <div className={classNames('page-container')}>
        <h1 className={styles.heading}>{heading}</h1>
        <div className={styles.gridContainer}>
          <div
            className={classNames(
              styles.innerGridContainer,
              styles.innerGridMinHeight
            )}
          >
            {outcome.grid1.length > 0 ? <Grid grids={outcome.grid1} /> : <></>}
          </div>
          <div className={styles.innerGridContainer}>
            {outcome.grid2.length > 0 ? <Grid grids={outcome.grid2} /> : <></>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Outcome
